import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import { API_BASE_URL } from "@/common/runtimeConfig";
import { clearAuthSession, getAuthCredential } from "@/common/session";

Vue.use(Toast);
const instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 5000,
})

instance.interceptors.request.use(config=>{
    const currentLang = localStorage.getItem('lang') || 'en_us'
    config.headers = config.headers || {}
    if(config.method === "post"){
        config.headers = {
            ...config.headers,
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    const credential = getAuthCredential()
    if(credential){
        config.headers = {
            ...config.headers,
            'token': Base64.encode(credential),
        }
    }
    config.headers = {...config.headers,'lang': currentLang,'lang2': currentLang}
	
    return config
},err=>{
    console.error('请求失败',err)
    return Promise.reject(err)
})

function parseResponseData(data) {
    if (typeof data !== "string" || data === "") {
        return data
    }

    try {
        return JSON.parse(data)
    } catch (plainJsonError) {
        try {
            return JSON.parse(Base64.decode(data))
        } catch (base64JsonError) {
            return data
        }
    }
}

function normalizePayload(payload) {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return payload
    }

    return {
        ...payload,
        data: parseResponseData(payload.data),
    }
}

let authRedirecting = false

/** Wrong pay-password / bind APIs often return business 401 — do not force logout. */
const PASSWORD_SENSITIVE_PATHS = [
    "setUserWirhdraw",
    "setPayPassword",
    "setLoginPassword",
    "setBank",
    "setCryptoBind",
]

function isPasswordSensitiveRequest(response) {
    const url = String((response && response.config && response.config.url) || "")
    return PASSWORD_SENSITIVE_PATHS.some((path) => url.indexOf(path) !== -1)
}

function handleAuthError(response) {
    if (!response) {
        return
    }

    const payload = response.data
    const httpUnauthorized = response.status === 401
    const businessUnauthorized = !!(
        payload &&
        (Number(payload.code) === 401 || payload.msg_key === "auth_error")
    )

    // Password/business 401 must not kick the user out (e.g. wrong withdraw password).
    if (!httpUnauthorized && businessUnauthorized && isPasswordSensitiveRequest(response)) {
        return
    }

    if (!httpUnauthorized && !businessUnauthorized) {
        return
    }

    clearAuthSession()
    const currentRoute = window.location.hash.replace(/^#/, "").split("?")[0].toLowerCase()
    if (authRedirecting || currentRoute === "/login") {
        return
    }

    authRedirecting = true
    window.location.replace(`${window.location.pathname}${window.location.search}#/Login`)
}

instance.interceptors.response.use(res=>{
    res.data = normalizePayload(res.data)
    handleAuthError(res)
    return res
},err=>{
    if (err.response) {
        err.response.data = normalizePayload(err.response.data)
        handleAuthError(err.response)
    }
    return Promise.reject(err)
})

async function http(option = {}) {
    try {
        if(option.method === 'get' || option.method === 'delete'){
            const response = await instance[option.method](
                api[option.url],
                {params: option.data}
            )
            return response.data
        }
        if(option.method === 'post' || option.method === 'put'){
            const response = await instance[option.method](
                    api[option.url],
                qs.stringify(option.data)
            )
            return response.data
        }
    } catch (error) {
        return error.response ? error.response.data : error
    }
    return null
}

export default http

